<template>
	<div class="bd-toast" v-html="msg"></div>
</template>

<script>
export default {
	name : "BDToast",
	data() {
		return{
			msg : '',
		}
	}
}
</script>

<style scoped>
.bd-toast{
	position: fixed;
	max-width: 80%;
	border-radius: 5px;
	background: rgba(0, 0, 0, 0.7);
	color: #fff;
	box-sizing: border-box;
	transition: opacity .3s linear;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: 10009;
	padding: 10px;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// toast.vue?08cc466e